// $(function () {
//     var page = 1;
//
//     $('body').on('click', '.interview__more', function (event) {
//         event.preventDefault();
//
//         axios.post('/api/interviews/pagination-render', {
//             lang: $('html').attr('lang'),
//             page: page + 1
//         }).then(function (response) {
//             var data = response.data.data;
//
//             page = data.current_page;
//
//             if (page === data.last_page) {
//                 $('body .interview__more').hide();
//             }
//
//             $('body .section__list .section__content ul').append(data.html);
//         })
//             .catch(function () {
//                 location.reload();
//             });
//     });
// });

import './_api';

$(function () {
    var page = 1;
    var lang = $('html').attr('lang');

    $('body').on('click', '.interview__more', function (event) {
        event.preventDefault();

        page = page + 1;

        fetchData(`
            {
                interviewPaginate(page: ${page}, lang: "${lang}", need_list_render: true) {
                    data {
                        id
                        published_time(date_string: true)
                        list_render
                    }
                    current_page
                    has_more_pages
                }
            }
        `).then(function (response) {
            $.each(response.interviewPaginate.data, function (index, interview) {
                $('body .section__list .section__content ul').append(interview.list_render);
            });

            page = response.interviewPaginate.current_page;

            if (!response.interviewPaginate.has_more_pages) {
                $('body .interview__more').remove();
            }
        });
    });
});
